export default (node) => {
  const messageNode = node.querySelector('[data-cart-toast-message]');
  let hideTimeout = null;
  let showTimeout = null;

  const show = (message) => {
    if (showTimeout) clearTimeout(showTimeout);
    if (hideTimeout) clearTimeout(hideTimeout);
    messageNode.textContent = message;

    // Position toast at the top of the cart items area
    const cartDrawer = document.querySelector('[data-cart-drawer-content]');
    if (cartDrawer) {
      const itemsContainer = cartDrawer.querySelector('.overflow-y-scroll');
      if (itemsContainer) {
        const rect = itemsContainer.getBoundingClientRect();
        node.style.top = rect.top + 'px';
      }
    }

    // Wait for cart drawer slide-in transition (800ms) before showing
    showTimeout = setTimeout(() => {
      node.classList.add('cart-toast-visible');

      hideTimeout = setTimeout(() => {
        node.classList.remove('cart-toast-visible');
      }, 5000);
    }, 800);
  };

  document.addEventListener('cart:error', (e) => {
    if (e.detail) show(e.detail);
  });
};
